import { Polyline,  Marker, Tooltip,  Pane, useMap} from 'react-leaflet';
import React, { useState, useEffect } from 'react';
import './styleCableDisplay.css';
import L from 'leaflet';
import useZoomLevel from '../Markers/useZoomLevel';
import { createElement, useMemo } from 'react';

const CableShowDisplay = ({
  showLines, showLines12, showLines24, showLines48, showLines8, showLines6, showLines4, showLines2, showLines1,showLines16, showLines32, showLines36,
  showLines64, showLines72, showLines96, showLines144, groupedCoordinatesWithColorTypeAndWidth, statusModalTerritory, descriptionOptic,
  openModalWithContent, showLinesTypeSolid, showLinesTypeDashed, onPolylineRef, showLineDenomination, showPonLayer, showKtvLayer, showEtherLayer,
  showLinesTypeBasement, showLinesTypeFacade, showLinesTypeLoft,showLinesTypeRoof, showLinesRankSummitToCanton, showAirBetweenHouses, showAirPillars }) => {

  const zoomLevel = useZoomLevel();

  const handlePolylineClick = (lineOpticId) => {
    const cleanedLineOpticId = typeof lineOpticId === 'string' ? lineOpticId.trim() : lineOpticId.toString().trim();

    const foundObject = descriptionOptic.find(item => {
      const cleanedHighwayLineId = typeof item.highwayLineId === 'string' ? item.highwayLineId.trim() : item.highwayLineId.toString().trim();
      return cleanedHighwayLineId === cleanedLineOpticId;
    });

    if (foundObject) {
      openModalWithContent(foundObject, statusModalTerritory);
    }
  };

  const renderPolyline = (index, lineOpticId) => {
    const { coordinates, color, type, width, fiberQuantity, activity } = groupedCoordinatesWithColorTypeAndWidth[lineOpticId];
    const trimmedType = type.trim();
    const polylineColor = activity === 1 ? color : 'gray';

    return (
      <Polyline
        key={index}
        positions={coordinates}
        color={polylineColor}
        dashArray={trimmedType !== 'solid' ? '5,10' : null}
        weight={width}
        draggable={true}
        ref={(el) => { onPolylineRef(lineOpticId, el); }}
        eventHandlers={{
          click: () => handlePolylineClick(lineOpticId), 
        }}
      >
        {zoomLevel > 16 && showLineDenomination && (
        <Tooltip 
        permanent 
        direction="center" 
        className="custom-tooltip"
      >
        <div  
          onClick={() => handlePolylineClick(lineOpticId)}  
          style={{ 
            color: color, 
            backgroundColor: 'transparent', 
            border: '1px solid silver', 
            borderRadius: '20px',
            padding: '3px',
            backgroundImage: 'linear-gradient(to right, #f0f0f0, #d0d0d0)', 
            margin: '0',
            cursor: 'pointer',
            pointerEvents: 'auto'
          }}
        >
          {fiberQuantity}
        </div>
      </Tooltip>
        )}
      </Polyline>
      
    );
  };

  const fiberMap = {
      144: showLines144,
      96: showLines96,
      72: showLines72,
      64: showLines64,
      48: showLines48,
      36: showLines36,
      32: showLines32,
      24: showLines24,
      16: showLines16,
      12: showLines12,
      8:  showLines8,
      6:  showLines6,
      4:  showLines4,
      2:  showLines2,
      1:  showLines1,
    };

    const typeMap = {
      solid: showLinesTypeSolid,
      dashed: showLinesTypeDashed,
    };

  if (!groupedCoordinatesWithColorTypeAndWidth || !descriptionOptic) {
    return <div>Данные загружаются...</div>;
  }

  return (
    showLines &&
    Object.keys(groupedCoordinatesWithColorTypeAndWidth).map((highwayLineId, index) => {
      const lineCableTypeId = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].cableTypeId;
      const lineType = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].type.trim();
      const fiberQuantity = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].fiberQuantity;
      const lineFeaturePon = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].pon;
      const lineFeatureKtv = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].ktv;
      const lineFeatureEther = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].ether;
      const lineRankCable = groupedCoordinatesWithColorTypeAndWidth[highwayLineId].rankCableId;
      
       // Если нужно показать все линии с rank 1, 2, 3
    if (!showLinesRankSummitToCanton && [1, 2, 4].includes(lineRankCable)) {
      return null;
    }

      if (showPonLayer) {
        if (lineFeaturePon === 1 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showKtvLayer) {
        if (lineFeatureKtv === 1 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showEtherLayer) {
        if (lineFeatureEther === 1 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showLinesTypeBasement) {
        if (lineCableTypeId === 4 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showLinesTypeFacade) {
        if (lineCableTypeId === 5 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showLinesTypeLoft) {
        if (lineCableTypeId === 6 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

       if (showLinesTypeRoof) {
        if (lineCableTypeId === 8 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (showAirBetweenHouses) {
         if ([3, 4, 5, 6].includes(lineCableTypeId)) {
            return renderPolyline(index, highwayLineId);
          }
        return null;
      }

       if (showAirPillars) {
        if (lineCableTypeId === 7 ) {
          return renderPolyline(index, highwayLineId);
        }
        return null;
      }

      if (fiberMap[fiberQuantity] && typeMap[lineType]) {
        return renderPolyline(index, highwayLineId);
      }
      











      
  
      // if (showLines96 && fiberQuantity === 96 &&  showLinesTypeSolid && lineType === "solid"  ) {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines96 && fiberQuantity === 96 && showLinesTypeDashed && lineType === "dashed" ) {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines72 && fiberQuantity === 72 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines72 && fiberQuantity === 72 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines64 && fiberQuantity === 64 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines64 && fiberQuantity === 64 && showLinesTypeDashed && lineType === "dashed" ) {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines48 && fiberQuantity === 48 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines48 && fiberQuantity === 48 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines36 && fiberQuantity === 36 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines36 && fiberQuantity === 36 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines24 && fiberQuantity === 24 && showLinesTypeSolid && lineType === "solid" ) {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines24 && fiberQuantity === 24 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines16 && fiberQuantity === 16 && showLinesTypeSolid && lineType === "solid" ) {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines16 && fiberQuantity === 16 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines12 && fiberQuantity === 12 && showLinesTypeSolid && lineType === "solid" ) {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines12 && fiberQuantity === 12 && showLinesTypeDashed && lineType === "dashed" ) {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines8 && fiberQuantity === 8 && showLinesTypeSolid && lineType === "solid" ) {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines8 && fiberQuantity === 8 && showLinesTypeDashed && lineType === "dashed" ) {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines4 && fiberQuantity === 4 && showLinesTypeSolid && lineType === "solid" )  {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines4 && fiberQuantity === 4 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines2 && fiberQuantity === 2 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines2 && fiberQuantity === 2 && showLinesTypeDashed && lineType === "dashed") {
      //   return renderPolyline(index, highwayLineId);
      // }

      // if (showLines1 && fiberQuantity === 1 && showLinesTypeSolid && lineType === "solid") {
      //   return renderPolyline(index, highwayLineId);
      // }
      // if (showLines1 && fiberQuantity === 1 && showLinesTypeDashed && lineType === "dashed" ) {
      //   return renderPolyline(index, highwayLineId);
      // }

      return null;
    })
  );
};

export default CableShowDisplay;

